<script lang="ts">
    import { createEventDispatcher } from "svelte"
    import { deleteCartItem, updateCartItem } from "../../../functions/CommerceAPIs/bigCommerce/cart"
    import { deleteCookie } from "../../../functions/utils"
    import ProductInCartPreview from "../product/ProductInCartPreview.svelte"
    const dispatcher = createEventDispatcher()
    async function removeItem(id: string) {
        if (cart.lines.length == 1) {
            deleteCookie("cartId")
            await deleteCartItem(cart.id, id)
            dispatcher("removeCart")
        } else cart = await deleteCartItem(cart.id, id)
    }
    interface UpdateItemQuantity {
        merchandiseId: string
        productId: string
        quantity: number
        entityId: string
    }
    async function updateItemQuantity(line: UpdateItemQuantity) {
        cart = await updateCartItem(cart.id, line)
    }
    export let cart: BKDFCart
</script>

<ul class="products">
    {#each cart.lines as item}
        <li class="product">
            <ProductInCartPreview
                item="{item}"
                on:updateQuantity="{(e) =>
                    updateItemQuantity({
                        merchandiseId: item.merchandise.id,
                        quantity: e.detail.quantity,
                        productId: item.merchandise.product.id,
                        entityId: item.id,
                    })}"
                on:remove="{() => removeItem(item.id)}"
            />
        </li>
    {/each}
</ul>

<style lang="less">
    .products {
        display: flex;
        width: 100%;
        flex-direction: column;
        gap: 24px;
        .product {
            width: 100%;
        }
    }
</style>
